import React, { FC } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AppLayout from "../Layouts/AppLayout";
import { Redirect, Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Home from "../../pages/Home";
import TherapeuticArea from "../../pages/TherapeuticArea";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    "@global tbody tr:nth-child(odd)": {
      background: "#EEF3F8",
    },
    "@global tbody tr:nth-child(even)": {
      background: "#FFF",
    },
    materialTableToolbar: { "& h6": { color: theme.palette.primary.main, fontWeight: 900 } },
    content: {
      padding: 16,
      marginTop: 24,
    },
    loading: {
      minHeight: 12,
      marginBottom: "12px",
    },
    headerContainer: {
      marginBottom: "1rem",
    },
    headerText: {
      color: theme.palette.primary.dark,
      display: "inline",
      marginLeft: "12px",
    },
    clearFiltersButton: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row-reverse",
    },
    dataContent: {
      filter: "brightness(0.85)",
    },
    filterMenu: {
      position: "absolute",
      zIndex: 1200,
    },
    filterMenuContainer: {
      position: "relative",
    },
    blurDisable: {
      filter: "blur(3px)",
      pointerEvents: "none",
    },
    disable: {
      pointerEvents: "none",
    },
  })
);

const App: FC = () => {
  const classes = useStyles();

  return (
    <AppLayout>
      <Router>
        <div className={classes.content}>
          <Switch>
            <Route exact path="/" render={() => <Home />} />
            <Route exact path="/therapeutic-area/:therapeuticArea" render={() => <TherapeuticArea />} />
            <Redirect to="/" />
          </Switch>
        </div>
      </Router>
    </AppLayout>
  );
};

export default App;
